module.exports = __webpack_public_path__ + "media/images/apple-logo-d6ceaa582ec2d45e454367c884f84fc8.svg";